import { createElement } from './globalFunctions'

/**
 * Creates a tab link for the SHP tabs.
 * @param {string} text - Text of the tab
 * @param {string} anchor - Anchor of the tab
 * @returns {HTMLElement} - Created tab link
 */
const createShpTabLink = (text, anchor) => {
	const shpTabLi = createElement('li', ['shp-tab'])
	const shpTabLink = createElement('a', ['shp-tab-link'], text)
	shpTabLink.href = anchor
	shpTabLi.appendChild(shpTabLink)
	return shpTabLi
}

/**
 * Removes the tabs switcher from the SHP tabs.
 * Used for convert switching tabs to anchors.
 */
const removeTabsSwitcher = () => {
	const shpTabLinks = document.querySelectorAll('.shp-tab-link')
	if (shpTabLinks.length === 0) return
	for (const tabLink of shpTabLinks) {
		tabLink.removeAttribute('role')
		tabLink.removeAttribute('data-toggle')
	}
}

/**
 * Removes the tabs switcher classes from the tab panes.
 * Used for removing switchers on tab panes and making them visible at once.
 */
const removeTabsSwitcherClasses = () => {
	const tabPanes = document.querySelectorAll('#tab-content .tab-pane')
	const shpTabLinks = document.querySelectorAll('.shp-tab-link')
	if (tabPanes.length === 0) return

	for (const tabPane of tabPanes) {
		tabPane.classList.remove('tab-pane', 'fade')
		tabPane.removeAttribute('role')
		const tabHeading = tabPane.querySelector('h3')
		if (!tabHeading) {
			for (const tabLink of shpTabLinks) {
				if (tabLink.getAttribute('href') === `#${tabPane.id}`) {
					const newHeading = createElement('h3')
					newHeading.textContent = tabLink.textContent
					tabPane.prepend(newHeading)
					break
				}
			}
		}
	}
}
const moveFlagsToImage = () => {
	const flagsExtra = document.querySelector('.p-image > .flags-extra')
	const flagsDefault = document.querySelector('.p-detail-info .flags-default')
	const pImage = document.querySelector('.p-image')
	if (flagsExtra && flagsDefault) {
		flagsDefault.prepend(flagsExtra)
		flagsDefault.classList.add('contains-extra')
	}
	if (pImage && flagsDefault) pImage.appendChild(flagsDefault)
}
const pInfoWrapper = document.querySelector('.p-info-wrapper')

const handleProductTop = () => {
	const detailInfo = document.querySelector('.p-detail-info')
	const productTitle = document.querySelector('.p-detail-inner-header h1')
	// const code = document.querySelector('.p-detail-inner-header .p-code')
	const giftsWrapper = document.querySelector('.p-gifts-wrapper')

	if (pInfoWrapper) {
		if (detailInfo) {
			pInfoWrapper.prepend(detailInfo)

			detailInfo.prepend(productTitle)
			if (giftsWrapper) detailInfo.append(giftsWrapper)
			// if (code) detailInfo.append(code)
		}
	}
}

// Turns the variants in select elements in table.detail-parameters into radio inputs, so all variants are visible at once. Requires setting of variants to "Rozdělené varianty" in Shoptet admin.
const variantsHandler = (id) => {
	$(function () {
		if ($(`.variant-list select.parameter-id-${id}`).length) {
			$(`.variant-list select.parameter-id-${id}`).each(function (option_index) {
				let so_classes = $(this).attr('class'),
					so_value = $(this).html(),
					so_attr1 = $(this).attr('data-parameter-id'),
					so_attr2 = $(this).attr('data-parameter-name'),
					so_attr3 = $(this).attr('id'),
					so_attr4 = $(this).attr('name'),
					so_newLabel = $('<div></div>').html(so_value)
				$(so_newLabel).attr('class', so_classes)
				$(so_newLabel).attr('data-parameter-id', so_attr1)
				$(so_newLabel).attr('data-parameter-name', so_attr2)
				$(so_newLabel).attr('id', so_attr3)
				$(so_newLabel).attr('name', so_attr4)
				$(so_newLabel).attr('value', option_index)
				$(this).replaceWith(so_newLabel)
			})
			if ($(`.variant-list:first-of-type .parameter-id-${id} option`).length == 1) {
				$(`.variant-list:first-of-type .parameter-id-${id}`).prepend('<option></option>')
			}
			if ($(`.variant-list:nth-of-type(2) .parameter-id-${id} option`).length == 1) {
				$(`.variant-list:nth-of-type(2) .parameter-id-${id}`).prepend('<option></option>')
			}
			if ($(`.variant-list:nth-of-type(3) .parameter-id-${id} option`).length == 1) {
				$(`.variant-list:nth-of-type(3) .parameter-id-${id}`).prepend('<option></option>')
			}
			$(`.variant-list .parameter-id-${id} option:first-of-type`).wrap('<span></span>')
			$(`.variant-list:first-of-type .parameter-id-${id} span option`).replaceWith(
				'<input type="radio" value name class="variant-default" checked="checked">'
			)
			$(`.variant-list:nth-of-type(2) .parameter-id-${id} span option`).replaceWith(
				'<input type="radio" value name class="variant-default" checked="checked">'
			)
			$(`.variant-list:nth-of-type(3) .parameter-id-${id} span option`).replaceWith(
				'<input type="radio" value name class="variant-default" checked="checked">'
			)
			$(`.variant-list .parameter-id-${id} option:not(:first-child)`).wrap("<label class='advanced-parameter'></label>")
			$(`.variant-list .parameter-id-${id} label option`).each(function (data_index) {
				let option_value = $(this).attr('value'),
					option_html = $(this).html(),
					option_select = $(this).attr('selected'),
					option_name = $(this).parents(`.parameter-id-${id}`).attr('name'),
					option_newLabel = $('<input>'),
					option_newInDiv = $("<span class='parameter-value'></span>").html(option_html),
					option_newBeDiv = $('<span class="advanced-parameter-inner show-tooltip" title=""></span>'),
					option_newApSpan = $('<span class="pkVS"></span>').html(option_html),
					option_data_index = data_index + 1
				$(option_newLabel).attr('value', option_value)
				$(option_newLabel).attr('name', option_name)
				$(option_newLabel).attr('selected', option_select)
				$(option_newLabel).attr('data-index', option_data_index)
				$(option_newLabel).attr('type', 'radio')
				$(this).parents('.hidden-split-parameter').children('span').children('input').attr('name', option_name)
				$(this).after(option_newInDiv)
				$(this).before(option_newBeDiv)
				$(this).parent('label').find('.advanced-parameter-inner').append(option_newApSpan)
				$(this).replaceWith(option_newLabel)
			})
			const selectedInput = document.querySelector('input[selected="selected"]')
			if (selectedInput) {
				selectedInput.checked = true
				selectedInput.parentElement.querySelector('.advanced-parameter-inner').classList.add('yes-before')
			}
		}
	})
}

const createAddToCartWrapper = () => {
	const addToCartWrapper = createElement('div', ['add-to-cart-wrapper'])
	const addToCartParent = document.querySelector('.add-to-cart')
	const addToCartBtn = document.querySelector('.add-to-cart .btn')
	// const availability = document.querySelector('.availability-value')
	const priceWrapper = document.querySelector('.p-final-price-wrapper')
	// const flagsExtra = document.querySelector('.p-image .flags-extra')
	const infoText = createElement('div', ['info-text'], 'Celý výťažok z benefičného obchodíka je venovaný na podporu psíkov bez domova')
	addToCartWrapper.appendChild(infoText)
	// if (flagsExtra) addToCartWrapper.appendChild(flagsExtra)
	// if (availability) addToCartWrapper.appendChild(availability)
	if (priceWrapper) addToCartWrapper.appendChild(priceWrapper)
	if (addToCartParent) addToCartWrapper.appendChild(addToCartParent)
	if (pInfoWrapper) pInfoWrapper.appendChild(addToCartWrapper)
	const quantity = document.querySelector('.add-to-cart .quantity')
	if (quantity && addToCartParent) addToCartParent.before(quantity)
	if (addToCartBtn && window.language === 'sk') addToCartBtn.textContent = 'Daruj' //jazyk
}

const moveTabsOnDetail = () => {
	const relatedFiles = document.querySelector('#relatedFiles')
	const basicDescription = document.querySelector('.basic-description')
	const extendedDescription = document.querySelector('.extended-description')

	if (basicDescription) {
		const shpTabs = document.querySelectorAll('.shp-tab')
		// if (shpTabs.length) {
		// 	for (const tab of shpTabs) {
		// 		tab.classList.remove('active')
		// 	}
		// }
		const heading = basicDescription.querySelector('h3')
		const descLi = document.querySelector('.shp-tab a[href="#description"]')
		//jazyk
		if (descLi)
			descLi.textContent =
				window.language === 'cs' ? 'Popis produktu' : window.language === 'sk' ? 'Detailný popis' : 'Product description'
		if (heading)
			heading.textContent =
				window.language === 'cs' ? 'Popis produktu' : window.language === 'sk' ? 'Popis produktu' : 'Product description'
	}
	if (extendedDescription) {
		const heading = extendedDescription.querySelector('h3')
		if (heading) heading.textContent = window.language === 'cs' ? 'Parametry' : window.language === 'sk' ? 'Parametre' : 'Parameters'
	}
	// if (relatedFiles) {
	// 	relatedFiles.classList.remove('tab-pane', 'fade')
	// 	relatedFiles.removeAttribute('role')
	// 	const filesHeading = createElement('h3', ['files-heading'], window.language === 'cs' ? 'Související soubory' : 'Súvisiace súbory')
	// 	if (basicDescription) {
	// 		basicDescription.appendChild(filesHeading)
	// 		basicDescription.appendChild(relatedFiles)
	// 	}

	// 	const relatedFilesTab = document.querySelector('a.shp-tab-link[href="#relatedFiles"]')
	// 	if (relatedFilesTab) {
	// 		relatedFilesTab.removeAttribute('role', 'data-toggle')
	// 		relatedFilesTab.removeAttribute('data-toggle')
	// 		relatedFilesTab.textContent = window.language === 'cs' ? 'Ke stažení' : 'Na stiahnutie'
	// 	}
	// }
	// const productVideos = document.querySelector('#productVideos')
	// if (productVideos) {
	// 	productVideos.classList.remove('tab-pane', 'fade')
	// 	productVideos.removeAttribute('role')
	// 	const videoHeading = productVideos.querySelector('h3')
	// 	if (videoHeading) videoHeading.textContent = window.language === 'cs' ? 'Související videa' : 'Súvisiace videá'
	// 	if (extendedDescription) extendedDescription.appendChild(productVideos)
	// }
	const slickSettings = {
		slidesToShow: 4,
		infinite: false,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					arrows: false,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1.3,
					dots: true,
				},
			},
		],
	}
	const productsRelatedHeader = document.querySelector('.products-related-header')
	const productsRelated = document.querySelector('.products-related')
	const detailTabsWrapper = document.querySelector('.p-detail-tabs-wrapper')
	if (productsRelated || productsRelatedHeader) {
		if (detailTabsWrapper) {
			if (productsRelated) {
				if (productsRelated) $(productsRelated).slick(slickSettings)

				detailTabsWrapper.after(productsRelated)
			}
			if (productsRelatedHeader) detailTabsWrapper.after(productsRelatedHeader)
		}
	}
	const productsAlternative = document.querySelector('#productsAlternative')
	if (productsAlternative) {
		productsAlternative.classList.remove('tab-pane', 'fade')
		// productsAlternative.classList.add('container')
		productsAlternative.removeAttribute('role')
		// const pDetail = document.querySelector('.p-detail')
		const alternativeHeading = createElement('h2', ['alternative-heading'], 'Podobné produkty')
		productsAlternative.prepend(alternativeHeading)
		const products = productsAlternative.querySelector('.products')
		// if (pDetail) pDetail.appendChild(productsAlternative)

		if (products) $(products).slick(slickSettings)
	}
}

const turnProductImgToCarousel = () => {
	const thumbnails = document.querySelectorAll('.p-thumbnail')

	if (thumbnails.length) {
		let mainImage = document.querySelector('.p-image > .p-main-image'),
			productImage = document.querySelector('.product-top .p-image-wrapper'),
			sliderWrapper = document.createElement('div')

		sliderWrapper.classList.add('custom-slider-wrapper')
		sliderWrapper.appendChild(mainImage)

		thumbnails.forEach((thumb, index) => {
			if (index > 0) {
				let imgUrl = thumb.getAttribute('href'),
					aEl = document.createElement('a'),
					imgEl = document.createElement('img')
				aEl.classList.add('p-main-image')
				aEl.href = imgUrl
				aEl.appendChild(imgEl)
				imgEl.src = imgUrl
				sliderWrapper.appendChild(aEl)
			}
		})

		productImage.querySelector('.p-image').appendChild(sliderWrapper)
		$(sliderWrapper).slick({
			infinite: false,
			arrows: false,
			slidesToShow: 1.1,
			slidesToScroll: 1,
			dots: true,
		})
	}
}

//moves thumnbail prev and next to thumbnails wrapper
const handleThumbnailArrows = () => {
	const thumbnails = document.querySelector('.p-thumbnails-wrapper')
	const prevArrow = document.querySelector('.thumbnail-prev')
	const nextArrow = document.querySelector('.thumbnail-next')
	if (thumbnails && prevArrow && nextArrow) {
		thumbnails.appendChild(prevArrow)
		thumbnails.appendChild(nextArrow)
	}
}
// moves favorites icon to the to social buttons and changes text in the icon
const handleFavoritesIcon = () => {
	const favoritesIcon = document.querySelector('#dkLabFavouriteDiv')
	const socialIcons = document.querySelector('.social-buttons-wrapper .link-icons')
	if (favoritesIcon && socialIcons) socialIcons.append(favoritesIcon)
}
const createDeliveryWrapper = () => {
	const availabilityValue = document.querySelector('.p-info-wrapper > .availability-value')
	const shippingOptions = document.querySelector('.detail-parameters .shipping-options')
	const deliveryTimeLabel = document.querySelector('.detail-parameters .delivery-time-label')
	const deliveryTime = document.querySelector('.detail-parameters .delivery-time')

	if (shippingOptions || deliveryTime) {
		const deliveryWrapper = createElement('div', ['delivery-wrapper'])
		if (availabilityValue) deliveryWrapper.appendChild(availabilityValue)
		if (deliveryTime) {
			const deliveryTimeWrapper = createElement('div', ['delivery-time-wrapper'])
			if (deliveryTimeLabel) {
				deliveryTimeLabel.textContent = '| dodanie do' //jazyk
				deliveryTimeWrapper.appendChild(deliveryTimeLabel)
			}
			deliveryTimeWrapper.appendChild(deliveryTime)
			if (availabilityValue) {
				availabilityValue.appendChild(deliveryTimeWrapper)
				availabilityValue.classList.add('has-delivery-time')
			} else deliveryWrapper.appendChild(deliveryTimeWrapper)
		}
		shippingOptions.closest('tr').remove()
		deliveryWrapper.appendChild(shippingOptions)
		pInfoWrapper.appendChild(deliveryWrapper)
	}
}

const createProductInfoWrapper = () => {
	const pCode = document.querySelector('.p-detail-inner-header .p-code')
	const warranty = document.querySelector('form#product-detail-form meta[itemprop="warranty"]')
	const productInfoWrapper = createElement('div', ['product-info-wrapper'])
	if (pCode) {
		productInfoWrapper.appendChild(pCode)
		const pCodeLabel = pCode.querySelector('.p-code-label')
		// jazyk
		if (pCodeLabel) pCodeLabel.textContent = window.language === 'cs' ? 'Kód produktu:' : 'Product code:'
	}
	if (warranty) {
		const warrantyWrapper = createElement('span', ['warranty-wrapper'])
		//jazyk
		const warrantyLabel = createElement('span', ['warranty-label'], window.language === 'cs' ? 'Záruka:' : 'Warranty:')
		const warrantyValue = createElement('span', ['warranty-value'], warranty.getAttribute('content'))
		warrantyWrapper.append(warrantyLabel, warrantyValue)
		productInfoWrapper.appendChild(warrantyWrapper)
	}

	if (window.language === 'cs' && typeof vymenaDetail != null && vymenaDetail) {
		const exchangeWrapper = createElement('span', ['exchange-wrapper'])
		const exchangeLabel = createElement('span', ['exchange-label'], vymenaDetail.tucnyText ? vymenaDetail.tucnyText : 'Výměna:')
		const exchangeValue = createElement('span', ['exchange-value'], vymenaDetail.mensiText ? vymenaDetail.mensiText : 'do 30 dní.')
		exchangeWrapper.append(exchangeLabel, exchangeValue)
		productInfoWrapper.appendChild(exchangeWrapper)
	}
	if (window.language !== 'cs' && typeof vymenaDetailEn != null && vymenaDetailEn) {
		const exchangeWrapper = createElement('span', ['exchange-wrapper'])
		const exchangeLabel = createElement('span', ['exchange-label'], vymenaDetailEn.tucnyText ? vymenaDetailEn.tucnyText : 'Return:')
		const exchangeValue = createElement(
			'span',
			['exchange-value'],
			vymenaDetailEn.mensiText ? vymenaDetailEn.mensiText : 'within 30 days.'
		)
		exchangeWrapper.append(exchangeLabel, exchangeValue)
		productInfoWrapper.appendChild(exchangeWrapper)
	}
	pInfoWrapper.appendChild(productInfoWrapper)
}

const handleSizeTable = () => {
	const sizeParameter =
		document.querySelector('#parameter-id-5') ||
		document.querySelector(".detail-parameters .hidden-split-parameter[data-parameter-name='Velikost']")
	const sizeTable = document.querySelector('.dklabZalozkaContent')
	if (sizeParameter && sizeTable) {
		const overlay = createElement('div', ['popup-overlay'])
		document.body.appendChild(overlay)
		overlay.addEventListener('click', () => {
			sizeTable.classList.remove('active')
			overlay.classList.remove('active')
		})

		sizeTable.classList.remove('tab-pane', 'fade')
		document.body.appendChild(sizeTable)

		const closeBtn = createElement('button', ['close-btn'])
		closeBtn.addEventListener('click', () => {
			sizeTable.classList.remove('active')
			overlay.classList.remove('active')
		})
		sizeTable.appendChild(closeBtn)
		const sizeButton = createElement('div', ['size-button'], window.language === 'cs' ? 'Tabulka velikostí' : 'Size table')
		// sizeTable.classList.add('hide')
		sizeButton.addEventListener('click', () => {
			sizeTable.classList.toggle('active')
			overlay.classList.toggle('active')
		})
		const parameterHeading = sizeParameter.parentElement.previousElementSibling
		// const parameterHeading = document.querySelector('.detail-parameters')

		if (parameterHeading) parameterHeading.appendChild(sizeButton)
	}
}

const handlePDescLink = () => {
	const cartDescLink = document.querySelector('.p-info-wrapper p[data-testid="productCardDescr"] a')
	if (!cartDescLink) return
	if (window.language === 'sk') cartDescLink.textContent = 'Zobrazit viac' //jazyk
	const shortDesc = document.querySelector('.p-info-wrapper .p-short-description p')
	if (!shortDesc) return
	cartDescLink.parentElement.remove()
	shortDesc.appendChild(cartDescLink)
}
const appendflagsExtraToFlags = () => {
	const flagsExtra = document.querySelector('.p-image .flags-extra')
	const flagsDefault = document.querySelector('.p-detail-info .flags-default')
	if (flagsExtra && flagsDefault) {
		flagsDefault.append(flagsExtra)
		flagsDefault.classList.add('contains-extra')
	}
}

const handleRatingBtns = () => {
	const ratingWrapper = document.querySelector('#ratingWrapper')
	if (!ratingWrapper) return
	const addComment = ratingWrapper.querySelector('.add-comment.rate-form-trigger')
	const rateForm = ratingWrapper.querySelector('#rate-form')
	if (addComment) {
		addComment.textContent = window.language === 'cs' ? 'Napsat' : 'Napísať' //jazyk
		addComment.classList.add('btn', 'btn-primary')
	}
	// setTimeout(() => {
	const votesWrap = document.querySelector('.shp-tabs-wrapper .votes-wrap')
	const loadRatings = document.querySelector('.load-next-wrap .js-load-ratings')
	if (votesWrap) {
		if (addComment) {
			if (rateForm) votesWrap.after(rateForm)
			votesWrap.after(addComment)
		}
		if (loadRatings) loadRatings.textContent = window.language === 'cs' ? 'Přečíst všechny recenze' : 'Prečítať všetky recenzie' //jazyk
		if (addComment || loadRatings) {
			const buttonWrapper = createElement('div', ['button-wrapper'])
			if (addComment) buttonWrapper.appendChild(addComment)
			if (loadRatings) buttonWrapper.appendChild(loadRatings)
			votesWrap.after(buttonWrapper)
		}
	}

	// })
}
export {
	createShpTabLink,
	removeTabsSwitcher,
	handleProductTop,
	createAddToCartWrapper,
	moveTabsOnDetail,
	turnProductImgToCarousel,
	handleFavoritesIcon,
	moveFlagsToImage,
	createProductInfoWrapper,
	createDeliveryWrapper,
	variantsHandler,
	removeTabsSwitcherClasses,
	handleSizeTable,
	handlePDescLink,
	appendflagsExtraToFlags,
	handleRatingBtns,
	handleThumbnailArrows,
}
